<template>
  <div>
    <el-dialog
      :visible="true"
      width="800px"
      class="chartDia"
      id="payChart"
      :show-close="false"
      @close="close"
      v-loading="loading"
    >
      <div slot="title" class="slotTit">确认支付</div>
      <div class="flexBox">
        <div class="leftDiv">
          <b>订单编号：</b>
          {{
            tableList[pageNo].type === 1
              ? tableList[pageNo].orderNo
              : tableList[pageNo].servicesOrderNo
          }}
        </div>
        <div class="rightDiv">
          <b>企业名称：</b>
          {{ tableList[pageNo].enterpriseName }}
        </div>
      </div>
      <div class="flexBox borderBtm">
        <div class="leftDiv">
          <b>项目名称：</b>
          {{ tableList[pageNo].projectName }}
        </div>
        <div class="rightDiv">
          <b>任务月度：</b>
          {{ tableList[pageNo].taskDt }}
        </div>
      </div>
      <!-- 四级 -->
      <div v-if="itemData.data.projectStructureType == 1">
        <div
          style="text-align: right;font-size:14px;color:#333;font-weight:500;margin-bottom:20px;padding-right:5%"
        >
          到账时间
        </div>
        <!-- 四级订单 -->
        <div v-if="tableList[pageNo].type === 1">
          <div
            class="flexBox"
            v-for="(item, index) in tableList[pageNo].payDetail"
            :key="index"
            style="align-items:baseline;border-bottom:1px solid #efefef;"
          >
            <div class="leftDiv">
              <b class="colorBf">供应商：</b>
              {{ item.supplieName }}
            </div>
            <div class="midDiv">
              <div>
                <label>银行账号：</label>
                {{ item.supplierBankNo }}
              </div>
              <div v-if="item.supplierBankName">
                <label>支行名称：</label>
                {{ item.supplierBankName }}
              </div>
              <div class="money">
                <label>项目结算金额：</label>
                {{ item.initProjectPrice | moneyFixed }}
              </div>
              <div class="money" v-if="tableList[pageNo].discountPrice">
                <label>优惠：</label>
                {{ tableList[pageNo].discountPrice | moneyFixed }}
              </div>
            </div>
            <div class="timeDiv">{{ item.finishPayDt | transAllTime }}</div>
          </div>
        </div>
        <!-- 四级服务费 -->
        <div
          class="flexBox"
          style="align-items:baseline;border-bottom:1px solid #efefef;"
          v-else
        >
          <div class="leftDiv">
            <b class="colorBf">平台：</b>
            {{ tableList[pageNo].platformName }}
          </div>
          <div class="midDiv">
            <div>
              <label>银行账号：</label>
              {{ tableList[pageNo].platformBankNo }}
            </div>
            <div v-if="tableList[pageNo].platformBankName">
              <label>支行名称：</label>
              {{ tableList[pageNo].platformBankName }}
            </div>
            <div class="money">
              <label>平台服务费：</label>
              {{ tableList[pageNo].platformServicesPrice | moneyFixed }}
            </div>
          </div>
          <div class="timeDiv">
            {{ tableList[pageNo].finishPayDt | transAllTime }}
          </div>
        </div>
        <!-- 订单支付 -->
        <div
          class="flexBox"
          style="padding-bottom:20px;border-bottom:1px solid #5A9CF8;"
        >
          <div class="leftDiv"></div>
          <div
            class="midDiv"
            style="flex-direction:row;color:#1989FA;align-items:center;font-size:20px;font-weight:500;"
          >
            <label style="color:#333333;font-weight:400;">订单支付金额：</label>
            <b v-if="tableList[pageNo].type === 1">
              {{ tableList[pageNo].orderPrice | money }}
            </b>
            <b v-else>{{ tableList[pageNo].platformServicesPrice | money }}</b>
            <span style="color:#333;">元</span>
          </div>
        </div>
      </div>
      <!-- 三级 -->
      <div v-else>
        <!-- 三级项目 -->
        <div class="flexBox" v-if="tableList[pageNo].type === 1">
          <div class="leftDiv">
            <b>
              {{
                itemData.data.projectStructureType == 2
                  ? '支付个体数：'
                  : '支付项目参与人数：'
              }}
            </b>
            {{ tableList[pageNo].pyaSum }}
          </div>
          <div class="rightDiv money">
            <b>项目结算金额：</b>
            {{ tableList[pageNo].projectPrice | moneyFixed }}
          </div>
        </div>
        <!-- 三级服务费 -->
        <div class="flexBox borderBtm money" v-else>
          <div class="leftDiv"></div>
          <div class="rightDiv">
            <b>平台服务费：</b>
            {{ tableList[pageNo].platformServicesPrice | moneyFixed }}
          </div>
        </div>
        <div class="flexBox borderBtm" style="border-color:#5A9CF8;">
          <div class="leftDiv"></div>
          <div class="rightDiv">
            <b>订单支付金额：</b>
            <!-- <b
              style="font-size:30px;"
            >{{tableList[pageNo].type===1?(tableList[pageNo].leftOrderPrice-tableList[pageNo].platformServicesPrice)|money:tableList[pageNo].platformServicesPrice|money}}</b>
            <span style="font-size:20px;">元</span>-->
            <b v-if="tableList[pageNo].type === 1">
              {{ tableList[pageNo].projectPrice | money }}
            </b>
            <b v-else>{{ tableList[pageNo].platformServicesPrice | money }}</b>
            <span style="color:#333;">元</span>
          </div>
        </div>
      </div>
      <div class="flexBox pageBox">
        <div style="margin-right:40px">
          共
          <span>{{ tableList.length }}</span>
          页
        </div>
        <el-button
          type="text"
          :disabled="pageNo < 1"
          class="pageBtn"
          @click="changePageNo(1)"
          style="margin-right:25px;"
        >
          上一页
        </el-button>
        <el-button
          type="text"
          :disabled="pageNo == tableList.length - 1"
          class="pageBtn"
          @click="changePageNo(2)"
          style="margin-right:40px;"
        >
          下一页
        </el-button>
        <div>
          当前页
          <span>{{ pageNo + 1 }}</span>
        </div>
      </div>
      <div style="text-align:right;margin-bottom:50px;padding:0 30px;">
        本次支付金额：
        <b style="font-size:30px;color:#1989FA">{{ allMoney | money }}</b>
        <i style="font-size:20px;font-style:normal">元</i>
      </div>
      <div
        class="flexBox"
        style="justify-content:space-between;background:#f9fafb;padding:20px;"
      >
        <div style="display:flex;">
          <b class="colorBf" style="margin-right:40px;line-height:40px;">
            支付通道：
          </b>
          <el-select v-model="key" class="accountType">
            <el-option value="baofu" label="众邦银行"></el-option>
          </el-select>
        </div>
        <div>
          余额：
          <b style="font-size:30px;">{{ info.balance | money }}</b>
          <i style="font-size:20px;font-style:normal">元</i>
        </div>
      </div>
      <div style="color:#BFBFBF;">支付完成前，请保证账号内余额充足</div>
      <div
        class="flexBox"
        style="width:40%;margin:auto;justify-content:space-between;margin-top:24px;"
      >
        <el-button
          style="border-radius:4px;border:2px solid rgba(25,137,250,1);color:#1989FA"
          @click="back"
        >
          返回
        </el-button>
        <el-button
          type="primary"
          @click="check('sendMsg')"
          :disabled="info.balance < allMoney"
        >
          全部支付
        </el-button>
      </div>
    </el-dialog>
    <component :is="componentName"></component>
  </div>
</template>
<script>
import sendMsg from './child/fenqiSendMsg.vue';
import { bfAccount, merge } from '@/api/ajax';
export default {
  inject: ['itemData'],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    type: {
      default: 2
    }
  },
  data() {
    return {
      loading: true,
      tableList: [{}],
      allMoney: '',
      pageNo: 0,
      info: {},
      feiyongList: [
        { label: '合同签约费', key: 1 },
        { label: '实名认证费', key: 2 }
      ],
      showDetail: false,
      key: 'baofu',
      componentName: '',
      gysList: [
        {
          orderNo: '123124324235',
          companyName: '北京一样科技邮箱公司',
          time: '2019-08-27'
        },
        {
          orderNo: '123124321114235',
          companyName: '北京烧烤华盛顿科技邮箱公司',
          time: '2019-08-27'
        }
      ],
      finalStatus: 0
    };
  },
  methods: {
    changePageNo(type) {
      if (type == 1) {
        this.pageNo -= 1;
      } else {
        this.pageNo += 1;
      }
    },
    close() {
      this.$parent.componentName = '';
    },
    check(componentName) {
      this.componentName = componentName;
    },
    back() {
      this.itemData.payList = [];
      this.$parent.componentName = 'fenqiPay';
    }
  },
  components: {
    sendMsg
  },
  async created() {
    let num = this.itemData.payList.join();
    if (this.itemData.data.projectStructureType == 1) {
      let {
        data: { data }
      } = await merge.mergeLoadCsoOrderFee({ csoOrderId: num });
      let list = [];
      data.list.filter(item => {
        if (item.payDetail) {
          //项目
          list.push({ ...item, type: 1 });
        }
        if (item.platformName) {
          //服务费
          list.push({ ...item, type: 2 });
        }
      });
      this.allMoney = data.totalPrice;
      this.tableList = list;
      this.loading = false;
    } else {
      let {
        data: { data }
      } = await merge.mergeThreeLevelLoadCsoOrderFee({ csoOrderId: num });
      let list = [];
      data.list.filter(item => {
        if (item.pyaSum) {
          list.push({ ...item, type: 1 });
        }
        if (item.platformServicesPrice) {
          list.push({ ...item, type: 2 });
        }
      });
      this.allMoney = data.totalPrice;
      this.tableList = list;
      this.loading = false;
    }
    try {
      let data2 = await bfAccount();
      this.info = data2.data.data;
    } catch (err) {
      console.error(err);
    }
  }
};
</script>
<style lang="scss">
#payChart {
  .el-dialog__body {
    padding: 30px 0;
  }
}
</style>
<style lang="scss" scoped>
.pageBox {
  span {
    color: #1989fa;
  }
  .pageBtn {
    // color: #1989fa;
  }
  div {
    color: #bfbfbf;
  }
}
.flexBox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 26px;
  padding: 0 20px;
  .leftDiv {
    width: 45%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 2%;
  }
  .rightDiv {
    width: 40%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .midDiv {
    width: 35%;
    text-align: left;
    display: flex;
    flex-direction: column;
    > div {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    label {
      width: 100px;
      text-align: right;
      color: #bfbfbf;
      font-size: 14px;
      line-height: 14px;
    }
    .money {
      color: #eb8e0e;
      label {
        color: #eb8e0e;
      }
    }
  }
  .timeDiv {
    width: 20%;
    text-align: center;
    font-weight: 400;
    color: #333;
  }
}
.colorBf {
  color: #bfbfbf;
}
.hint {
  color: #bfbfbf;
  font-size: 12px;
  margin-bottom: 16px;
}
.accountType {
  width: 138px;
}
.chargeBtn {
  width: 92px;
  height: 36px;
  background: rgba(235, 142, 14, 1);
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  padding: 0;
  margin-left: 20px;
}
.imgBox {
  img {
    width: 112px;
    height: 112px;
    margin-bottom: 20px;
  }
  .imgLabel {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .imgDes {
    color: #b4cfff;
    margin-bottom: 50px;
    font-size: 14px;
  }
}
.chartDia {
  .borderBtm {
    padding-bottom: 20px;
    border-bottom: 1px solid #efefef;
  }
}
.money {
  color: #eb8e0e;
  label {
    color: #eb8e0e;
  }
}
</style>
